import { Button } from '@dsi/react-eds';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { useHistory } from 'react-router-dom';

import useUser from '../Context/UserDataContext';

export default function SysPanel({ hidden, onClose }) {
  const { data } = useUser();
  const ref = useRef();
  const classes = classNames('settings', { hidden });
  const history = useHistory();

  return (
    <div ref={ref} className={classes}>
      <div className="syspanel-top">
        <span className="syspanel-title" />
        <i className="syspanel-close icon icon-cross" onClick={onClose} />
      </div>
      <div className="row">
        <div className="column sm-12 container">
          <div className="profile mb-2">
            <i className="icon icon-profile" />
            {/* {useQuery(
              ["user", userName, role],
              () => fetchUserName(userName, role),
              {
                enabled: !!userName && !!role,
              }
            )} */}
            <div className="username">{data?.data.userName}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

SysPanel.defaultProps = {
  hidden: false
};

SysPanel.propTypes = {
  hidden: PropTypes.bool,
  onClose: PropTypes.func.isRequired
};
